import { axios, BaseApiUrl, BaseUrl } from "../axios_config";

// 增值服务列表
export const GetAddServicesTaskListAsync = (params) => {
	return axios
		.post(`${BaseApiUrl}/AddServices/GetAddServicesTaskListAsync`, {
			...params,
		})
		.then((res) => res.data);
};

export const FeeOrgDetailExport = `${BaseApiUrl}/FeeOrg/FeeOrgDetailExport`;

export const GetCurrencyServiceModelList = (params) => {
	return axios.post(`${BaseApiUrl}/Util/GetCurrencyServiceModelList`, params);
};

export const AddFeeDetail = (params) => {
	return axios.post(`${BaseApiUrl}/FeeOrg/AddFeeDetail`, params);
};

// 增值服务类型
export const GetFeeType = (params) => {
	return axios.get(`${BaseApiUrl}/AddServices/GetFeeType`, { params: params })
		.then((res) => res.data);
};
//箱子信息
export const GetBoxInfo = (params) => {
	return axios.get(`${BaseApiUrl}/AddServices/GetBoxInfo`, { params: params })
		.then((res) => res.data);
};
export const AddServices = (params) => {
	return axios.post(`${BaseApiUrl}/AddServices/AddServices`, params);
};
//上传文件
export const UploadAddServiceFile = `${BaseApiUrl}/AddServices/UploadAddServiceFile`;
//手动上传文件
export const InsertAddServiceFile = `${BaseApiUrl}/AddServices/InsertAddServiceFile`;
// 修改增值服务状态
export const EditServiceStatus = (params) => {
	return axios.get(`${BaseApiUrl}/AddServices/EditServiceStatus`, {
		params: params,
	});
};

// 标记完成
export const CompleteServices = (params) => {
	return axios.post(`${BaseApiUrl}/AddServices/CompleteServices`, params);
};
export const AddServicesAsyncOut = `${BaseApiUrl}/AddServices/AddServicesAsyncOut`;
